import { useEffect } from 'react';
import { Form, Input, Checkbox } from 'antd';
import { useLocalObservable, observer } from 'mobx-react-lite';
import Copyright from '@/components/Copyright';
import { IconLock, IconUser } from '@emooa/icon';
import { authApi } from '@/apis';
import { getStorage, removeStorage, setStorage } from '@/utils/storage';
import { C_STORAGE } from '@/constant';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@/store';
import { isEmpty } from 'lodash';
import { Button } from '@emooa/ui';
import './login.less';

export default observer(() => {
  const state = useLocalObservable(() => ({
    username: getStorage(C_STORAGE.USERNAME),
    password: getStorage(C_STORAGE.PASSWORD),
    sending: false,
    setSending(sending: boolean) {
      this.sending = sending;
    },
    fetching: false,
    setFetching(fetching: boolean) {
      this.fetching = fetching;
    },
  }));
  const store = useStore();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getStorage(C_STORAGE.AUTH);
    if (!isEmpty(auth)) {
      store.setAuth(auth);
      navigate('/');
    }
  }, []);

  const onFinish = async (values: {
    username: string;
    password: string;
    remember: boolean;
  }) => {
    if (values.remember === true) {
      setStorage(C_STORAGE.USERNAME, values.username);
      setStorage(C_STORAGE.PASSWORD, values.password);
    } else {
      removeStorage(C_STORAGE.USERNAME);
      removeStorage(C_STORAGE.PASSWORD);
    }

    state.setFetching(true);
    try {
      const params: API.Auth.LoginParams = {
        username: values.username,
        password: values.password,
      };
      const data: API.Auth.LoginResult = await authApi.signIn(params);
      setStorage(C_STORAGE.TOKEN, data.token);
      const info = await authApi.getInfo();
      store.setAuth(info);
      navigate('/');
    } finally {
      state.setFetching(false);
    }
  };

  return (
    <div className="account-layout">
      <div className="account-layout-layer" />
      <div className="h-full flex items-center justify-center">
        <div className="relative w-md px-16 rounded-lg bg-white/50 backdrop-sepia-0">
          <h1 className="text-3xl text-center m-4 font-bold">登录</h1>
          <Form form={form} onFinish={onFinish}>
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入您的账号!' }]}
              initialValue={state.username}
            >
              <Input
                placeholder="账号"
                prefix={<IconUser />}
                className="w-96"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码!' }]}
              initialValue={state.password}
            >
              <Input.Password
                placeholder="密码"
                prefix={<IconLock />}
                type="password"
              />
            </Form.Item>
            <Form.Item className="m-0">
              <Button
                full
                type="primary"
                htmlType="submit"
                loading={state.fetching}
              >
                {state.fetching ? '登录中..' : '登录'}
              </Button>
            </Form.Item>
            <Form.Item
              name="remember"
              valuePropName="checked"
              initialValue={true}
            >
              <Checkbox>记住密码</Checkbox>
            </Form.Item>
          </Form>
        </div>
      </div>
      <footer>
        <Copyright />
      </footer>
    </div>
  );
});
